import { SplitDocumentRequest, SplitDocumentResponse } from '@/types/documents'
import useCreateDetail, {
  UseCreateDetailOptions,
} from '../core-hooks/useCreateDetail'
import { createDetail } from '../request-wrappers'

/**
 * MARK: Action Hook: Bulk Split Create Documents
 * Used to create documents by splitting a multi-page document.
 */
export function useBulkSplitCreateDocuments(
  options?: UseCreateDetailOptions<
    SplitDocumentRequest,
    SplitDocumentResponse[]
  >,
) {
  const mutation = useCreateDetail<
    SplitDocumentRequest,
    SplitDocumentResponse[]
  >({
    serviceFn: (serviceFnOptions) => {
      return createDetail<SplitDocumentRequest, SplitDocumentResponse[]>({
        url: '/v2/pd-ocr/split_document',
        ...serviceFnOptions,
      })
    },
    ...options,
  })

  return {
    bulkSplitCreateDocuments: mutation.mutate,
    bulkSplitCreateDocumentsAsync: mutation.mutateAsync,
    ...mutation,
  }
}
